import {Plugin} from 'prosemirror-state';
import {Decoration, DecorationSet} from 'prosemirror-view';

export const cardContentHeader = new Plugin({
    props: {
        decorations: state => {
            const decorations = [];
            state.doc.descendants((node, pos) => {
                if (node.type !== state.schema.nodes.card_content_header || node.textContent.length > 0) {
                    return;
                }

                decorations.push(Decoration.node(pos, pos + node.nodeSize, {
                        class: 'empty-title'
                    })
                );
            });

            return DecorationSet.create(state.doc, decorations);
        }
    }
});